// Business or technical names everywhere a view shows the data (Now, the search, Systems, their peeks and maps; not
// Settings, which shows both):
// "Invoices to e-invoice operator", "Dynamics 365", "sales orders" or the names as they are in the data:
// "[FIN] Invoices to e-invoice operator", "ERP", "ErpSalesOrder". A display preference of the viewer (like the theme),
// remembered in the browser; it does not change what is shown, only how it is named.
import { useSyncExternalStore } from 'react';

export type NameMode = 'business' | 'technical';
const KEY = 'mv.names';
const listeners = new Set<() => void>();

function read(): NameMode {
  try {
    return window.localStorage.getItem(KEY) === 'technical' ? 'technical' : 'business';
  } catch {
    return 'business';
  }
}
let current: NameMode = typeof window === 'undefined' ? 'business' : read();

export const getNameMode = (): NameMode => current;
export function setNameMode(mode: NameMode): void {
  if (mode === current) return;
  current = mode;
  try { window.localStorage.setItem(KEY, mode); } catch { /* a preference only */ }
  for (const l of listeners) l();
}
const subscribe = (l: () => void) => { listeners.add(l); return () => listeners.delete(l); };
export const useNameMode = (): NameMode => useSyncExternalStore(subscribe, getNameMode, () => 'business');

/** The pages the preference applies to: every view of the data (Settings shows both names side by side). */
export const technicalScope = (pathname: string): boolean => !/^\/(settings|login)(\/|$)/.test(pathname);

// Whether names are technical right now (set while rendering the systems side; read by noun(), systemName(), stripSystem())
let technicalNow = false;
export const namesTechnical = (): boolean => technicalNow;
export function setNamesTechnical(on: boolean): void { technicalNow = on; }
